// Orders of one organization (or, for the admin, of every one): the
// framework's order screens (aldoo-ra/StoreOrders) over aldoo.com's orders
// API — a seller reads the orders with its products — in the vendor portal's
// words, with the pickup office on the courier's map.
import React from "react"
import StoreOrders from "aldoo-ra/StoreOrders"
import { ORDERS_API, useOrderTexts, useOrderLocale, renderPickup, renderQR, renderShip, renderShipment, renderOfficePicker, extraPrints } from "./orders-setup"

// the help center's article on the orders (aldoo-com-api scripts/help-center/vendor/articles/orders.html):
// the whole of it beside the title, its sections where the screen does what they describe
const HELP = { orders: "vendor.orders", states: "vendor.orders#states", order: "vendor.orders#order", ship: "vendor.orders#ship", cancel: "vendor.orders#cancel", returns: "vendor.orders#returns", refund: "vendor.orders#refund", invoice: "vendor.orders#invoice" }

// `viewer`: "vendor" in the vendor portal (the seller's own screen), "admin" on the admin's
export default function OrdersTab({ orgId, viewer = "admin" }) {
  const locale = useOrderLocale()
  return <StoreOrders orgId={orgId || null} viewer={viewer} api={ORDERS_API} useTexts={useOrderTexts} locale={locale} renderPickup={renderPickup} renderQR={renderQR} renderShip={renderShip} renderShipment={renderShipment} renderOfficePicker={renderOfficePicker} extraPrints={extraPrints} helpKeys={HELP} />
}
